/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';

import { AppUtilityService } from './../../../core/services/app-utility.service';
import { LocoDetail } from '../../../core/model/loco-detail.model';
import { LocoIcon } from './../../model/loco-icon.model';
import { Tab } from './../../../core/model/tab.model';
import { TrainData } from '../../../core/model/train-data.model';
import { LocoIncident } from './../../../loco/shared/model/loco-incident.model'
import { LmsLoggerService } from '../../../core/services/lms-logger.service';
//import { Console } from 'console';


/**
 * @export
 * @class LmsLocoSvgComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-loco-svg',
  templateUrl: './lms-loco-svg.component.html',
  styleUrls: ['./lms-loco-svg.component.scss']
})
export class LmsLocoSvgComponent implements OnInit, OnChanges {

  @Input() loco: LocoDetail;
  @Input() isDefaultLocoIcon: boolean;
  @Input() svgWidthClass: string;
  @Input() isTerminalStatusSection: boolean;
  @Input() isDueOutShopScreen: boolean;
  @Input() isStorageScreen: boolean;
  @Input() isYardLocalScreen: boolean;
  @Input() tab: Tab;
  @Input() trainData: TrainData;
  textDisplayOverTheIcon: string;
  isShadowIcon: boolean;
  shadowOverText: string;
  locoData;
  background;
  locoIcon: LocoIcon = {};
  formDueDead: string;

  constructor(private appUtilityService: AppUtilityService,
    private lmsLoggerService: LmsLoggerService) { }
  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LmsLocoSvgComponent
   */
  ngOnInit() {
    this.init();
  }

  ngOnChanges() {
    this.init();
  }

  /**
   * Initialize the loco icon properties.
   * @memberof LmsLocoSvgComponent
   */
  init() {
    this.locoIcon = {};
    this.textDisplayOverTheIcon = '';
    this.isShadowIcon = false;
    this.shadowOverText = '';
    if (this.loco) {
      if (this.loco.duration && this.loco.duration.length === 4) {
        let timeDiff = 0;
        if (this.tab && this.tab.lastRefreshTime) {
          const date1 = new Date(this.tab.lastRefreshTime);
          const date2 = new Date();
          timeDiff = date2.getMinutes() - date1.getMinutes();
        }
        this.locoIcon.unitArrivedAtTerminalHour = this.loco.duration.substring(0, 2);
        this.locoIcon.unitArrivedAtTerminalMinute = this.loco.duration.substring(2, 4);
        this.countdown(this.loco.locomotiveIdentifier, this.locoIcon.unitArrivedAtTerminalHour, this.locoIcon.unitArrivedAtTerminalMinute, timeDiff);
      } else {
        this.locoIcon.unitArrivedAtTerminalHour = '00';
        this.locoIcon.unitArrivedAtTerminalMinute = '00';
      }
      if (this.loco.directionFacing && this.trimUpperCaseValue(this.loco.directionFacing) === 'B') {
        this.locoIcon.locoDirectionClass = '';
      } else {
        this.locoIcon.locoDirectionClass = 'forward-view';
      }
      if (!this.loco.directionFacing || (this.loco.directionFacing && this.loco.directionFacing.trim().length === 0) || (this.isNotBlank(this.loco.directionFacing)
        && this.trimUpperCaseValue(this.loco.directionFacing) !== 'B'
        && this.trimUpperCaseValue(this.loco.directionFacing) !== 'F')) {
        this.locoIcon.textUnderLineClass = 'underline-text';
      }
      if (this.loco.notesFlag && this.trimUpperCaseValue(this.loco.notesFlag) === 'Y') {
        this.locoIcon.textItalicClass = 'italic-text';
      }

      if (this.loco.locomotiveIdentifier) {
        this.loco.locomotiveIdentifier = this.loco.locomotiveIdentifier.trim();
        const v = this.loco.locomotiveIdentifier.match(/\d+/);
        if (v) {
          this.locoIcon.locoInitial = (v.index <= 4) ? this.loco.locomotiveIdentifier.substring(0, v.index).trim()
            : this.loco.locomotiveIdentifier.substring(0, 4).trim();
          this.locoIcon.locoNumber = (v.index <= 4) ? this.loco.locomotiveIdentifier.substring(v.index, this.loco.locomotiveIdentifier.length).trim()
            : this.loco.locomotiveIdentifier.substring(4, this.loco.locomotiveIdentifier.length).trim();
          if (this.locoIcon.locoNumber) {
            this.locoIcon.locoNumber = this.locoIcon.locoNumber.replace(/^0+/, '');
          }
        }
      }
      if (this.loco.shadowIndicator && this.trimUpperCaseValue(this.loco.shadowIndicator) === 'S') {
        this.isShadowIcon = true;
      } else if (this.loco.locomotiveIdentifier) {
        this.isShadowIcon = this.isShadowLocomotive(this.loco.locomotiveIdentifier);
      }
      if (this.loco && this.loco.locomotiveIdentifier && this.loco.clazz) {
        this.setShadowLocomotive(this.trimUpperCaseValue(this.loco.locomotiveIdentifier), this.loco.clazz);
      }
      if (this.loco && this.loco.ptcEquipped && this.trimUpperCaseValue(this.loco.ptcEquipped) === 'Y') {
        this.shadowOverText = 'PTC';
      }

      this.locoIcon.isUnitInTheShop = (this.loco.shoppedStored &&
        this.trimUpperCaseValue(this.loco.shoppedStored) === 'S') ? true : false;

      this.locoIcon.isStoredUnit = (this.loco.shoppedStored &&
        this.trimUpperCaseValue(this.loco.shoppedStored) === 'W') ? true : false;

      if (this.locoIcon.locoDirectionClass === 'forward-view') {
        this.locoIcon.wheelFrontClass = (this.loco.partialPower &&
          this.trimUpperCaseValue(this.loco.partialPower) === 'Y') ? 'partial-power' : '';

        this.locoIcon.wheelEndClass = (this.loco.trailUseOnly &&
          this.trimUpperCaseValue(this.loco.trailUseOnly) === 'Y') ? 'high-pilot' : '';
      } else {
        this.locoIcon.wheelEndClass = (this.loco.partialPower &&
          this.trimUpperCaseValue(this.loco.partialPower) === 'Y') ? 'partial-power' : '';

        this.locoIcon.wheelFrontClass = (this.loco.trailUseOnly &&
          this.trimUpperCaseValue(this.loco.trailUseOnly) === 'Y') ? 'high-pilot' : '';
      }

      if (this.loco.nextDailyMIDueDate) {
        const dailyMIDueDate = new Date(this.loco.nextDailyMIDueDate);
        const currentDate = new Date();
        currentDate.setHours(0); currentDate.setMinutes(0); currentDate.setSeconds(0);

        if (this.getDayDiff(dailyMIDueDate, currentDate) >= 0 &&
          (this.getDayDiff(dailyMIDueDate, currentDate) + 1) <= 7) {
          this.locoIcon.isDueMechanicalInspectionWithIn7Days = true;
        } else if (this.getDayDiff(dailyMIDueDate, currentDate) < 0) {
          this.locoIcon.isDueMechanicalInspectionPastDue = true;
        }
      }

      if (this.loco.nextAirFlowDate) {
        const nextAirFlowDate = new Date(this.loco.nextAirFlowDate);
        const currentDate = new Date();
        currentDate.setHours(0); currentDate.setMinutes(0); currentDate.setSeconds(0);

        if (this.getDayDiff(nextAirFlowDate, currentDate) >= 0 &&
          (this.getDayDiff(nextAirFlowDate, currentDate) + 1) <= 7) {
          this.locoIcon.isDueAirFlowMeterCalibration7Days = true;
        }
      }

      this.locoIcon.isClockDisplayed = !this.isDueOutShopScreen && !this.isStorageScreen && (this.isTerminalStatusSection || (this.loco && this.loco.isTerminalStatusLoco));
      if (this.locoIcon.isClockDisplayed) {
        this.locoIcon.clockDisplayedClass = 'withclock';
      }
      this.drawIdleHours();
      this.setAxle();
      this.setLocomotiveOuterColor(this.loco.permanentTag, this.loco.locoTag, this.loco.assignedMaintPoint, this.loco.clazz);
      this.setQuestionMark();
      this.configureAntenna();
      this.drawLocoStatus();
      this.locoIcon.layer5Style = this.getStyles();
      this.displayProjectedOut();
      this.drawMilesLeftAndDueOut();
      this.setBackgroud();
    }
    // Set formDueDead from deadDate with proximity logic (matching original formDue behavior)
    if (this.loco && this.loco.deadDate) {
      // Check if deadDate meets proximity criteria first (past due OR within 2 weeks)
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0); // Reset time to start of day

      const deadDate = new Date(this.loco.deadDate);
      deadDate.setHours(0, 0, 0, 0); // Reset time to start of day

      const daysDiff = this.getDayDiff(deadDate, currentDate);

      // Only populate formDueDead if: deadDate is past due (daysDiff < 0) OR within 14 days (daysDiff >= 0 && daysDiff <= 14)
      if (daysDiff < 0 || (daysDiff >= 0 && daysDiff <= 14)) {
        // Accept both MM-DD-YYYY and MM/DD/YYYY formats
        const normalizedDate = this.loco.deadDate.replace(/\//g, '-');
        const parts = normalizedDate.split('-');
        if (parts.length === 3) {
          this.formDueDead = 'Q' + parts[1]; // parts[1] is the day
        } else {
          this.formDueDead = '';
        }
      } else {
        // Date is outside proximity range - leave formDueDead empty (matching original formDue behavior)
        this.formDueDead = '';
      }
    } else {
      this.formDueDead = '';
    }
  }

  /**
   * Add class to wheels.
   * @param {string} check
   * @returns
   * @memberOf LmsLocoSvgComponent
   */
  addClass(check: string) {
    if (check === 'layer11') {
      document.getElementsByClassName('wheel-front')[0].classList.add('partial-power');
      document.getElementsByClassName('wheel-end')[0].classList.add('high-pilot');
    } if (check === 'layer3') {
      if (this.locoIcon && this.locoIcon.isFormPastDue) {
        return check;
      } else {
        return '';
      }
    } else {
      return check;
    }
  }

  /**
   * Get style as per loco object data.
   * @param {LocoDetail} loco
   * @returns
   * @memberOf LmsLocoSvgComponent
   */
  getStyles() {
    if (this.isRemoteControlledPlatformLocomotive()) {
      this.locoIcon.showUpperLid = false;
      this.locoData = {
        'border-bottom-style': 'solid',
        'border-bottom-width': '4px',
        'border-top': 'none',
        'border-left': 'none',
        'border-right': 'none',
        'width': '85%',
        'left': '9px'
      };
    } else if (this.isPTCEquippedSlug()) {
      this.locoIcon.showUpperLid = false;
      this.locoData = {
        'border-top': 'none',
        'border-bottom-style': 'solid',
        'border-bottom-width': '4px',
        'border-right': 'none'
      };
    } else if (this.isSlugLocomotive()) {
      this.locoIcon.showUpperLid = false;
      this.locoData = {
        'border-top': 'none',
        'border-bottom-style': 'solid',
        'border-bottom-width': '4px',
        'border-right': 'none'
      };
    } else if (this.isPTCEquippedWithDefect()) {
      this.locoIcon.showUpperLid = false;
      this.locoData = {
        'border-left-style': 'solid',
        'border-left-width': '4px',
        'border-bottom-style': 'solid',
        'border-bottom-width': '4px',
        'border-right-style': 'solid',
        'border-right-width': '4px',
        'border-top-style': 'solid',
        'border-top-width': '4px'
      };
    } else if (this.isPTCEquipped()) {
      this.locoIcon.showUpperLid = false;
      this.locoData = {
        'border-left-style': 'solid',
        'border-left-width': '4px',
        'border-bottom-style': 'solid',
        'border-bottom-width': '4px',
        'border-right-style': 'solid',
        'border-right-width': '4px',
        'border-top-style': 'solid',
        'border-top-width': '4px'
      };
    } else {
      this.locoIcon.showUpperLid = true;
      this.locoData = {
        'border-left-style': 'solid',
        'border-left-width': '4px',
        'border-bottom-style': 'solid',
        'border-bottom-width': '4px',
        'border-right-style': 'solid',
        'border-right-width': '4px'
      };
    }
    return Object.assign(this.locoData, this.getBackground());
  }

  /**
   * Return background color as per loco object.
   * @param {LocoDetail} loco
   * @returns
   * @memberOf LmsLocoSvgComponent
   */
  getBackground() {
    if (this.locoIcon.locoPrimaryColor && this.locoIcon.locoSecondaryColor) {
      return {
        'background': 'linear-gradient(90deg, ' + this.locoIcon.locoSecondaryColor + ' 50%, ' + this.locoIcon.locoPrimaryColor + ' 50%)'
      };
    } else if (this.locoIcon.locoPrimaryColor && !this.locoIcon.locoSecondaryColor) {
      return {
        'background': 'linear-gradient(90deg, ' + this.locoIcon.locoPrimaryColor + ' 50%, ' + this.locoIcon.locoPrimaryColor + ' 50%)'
      };
    } else if (!this.locoIcon.locoPrimaryColor && this.locoIcon.locoSecondaryColor) {
      return {
        'background': 'linear-gradient(90deg, ' + this.locoIcon.locoSecondaryColor + ' 50%, ' + this.locoIcon.locoSecondaryColor + ' 50%)'
      };
    }
  }

  /**
   * Get Locomotive ID.
   * @param {string} value
   * @returns
   * @memberOf LmsLocoSvgComponent
   */
  getLocomotiveId(value: string) {
    if (value) {
      value = value.trim();
      const v = value.match(/\d+/);
      if (v) {
        const locoInitial = (v.index <= 4) ? value.substring(0, v.index).trim() : value.substring(0, 4).trim();
        const locoNumber = (v.index <= 4) ? value.substring(v.index, value.length).trim() : value.substring(4, value.length).trim();
        return locoInitial + ' ' + locoNumber.replace(/^0+/, '');
      }
    }
  }

  /**
   * Draw idle hours over the icon.
   * @memberof LmsLocoSvgComponent
   */
  drawIdleHours() {
    const tempStr = this.loco.specificGPSIdle;
    if (this.isNotBlank(tempStr)) {
      let tempStr2 = tempStr.substring(0, 1);
      if (tempStr2 && tempStr2 === '0') {
        if (tempStr.length >= 2) {
          tempStr2 = tempStr.substring(1, 2);
          if (this.isNotBlank(tempStr2) && (this.trimUpperCaseValue(tempStr2) === '8' ||
            this.trimUpperCaseValue(tempStr2) === '4' || this.trimUpperCaseValue(tempStr2) === '9')) {
            this.textDisplayOverTheIcon = tempStr2;
          } else {
            this.textDisplayOverTheIcon = tempStr;
          }
        }
      } else {
        this.textDisplayOverTheIcon = tempStr;
      }
    }
  }

  /**
 * This is used to check whether it is number or not
 * @param {string} value
 * @returns {boolean}
 * @memberOf LmsLocoSvgComponent
 */
  isNumeric(value: string): boolean {
    return !isNaN(parseInt(value, 10));
  }

  /**
   * This is used to check whether it is alphabet or not
   * @param {any} inputValue
   * @returns {boolean}
   * @memberOf LmsLocoSvgComponent
   */
  isAlphabetic(inputValue): boolean {
    const letters = /^[A-Za-z]+$/;
    return letters.test(inputValue);
  }

  /**
  * Check for shadow locomotive.
  * @param {string} locomotiveIdentifier
  * @returns {boolean}
  * @memberOf LmsLocoSvgComponent
  */
  isShadowLocomotive(locomotiveIdentifier: string): boolean {
    if (locomotiveIdentifier && locomotiveIdentifier.length >= 10) {
      const locoInitial = locomotiveIdentifier.substring(0, 4);
      const locoNumber = locomotiveIdentifier.substring(8, locomotiveIdentifier.length);
      if ((locoInitial && this.trimUpperCaseValue(locoInitial) === 'ZZZZ') &&
        (locoNumber && this.trimUpperCaseValue(locoNumber) === 'ZZZZZZ')) {
        return true;
      }
    }
  }

  /**
  * configure for shadow locomotive.
  * @param {string} locomotiveIdentifier
  * @memberOf LmsLocoSvgComponent
  */
  setShadowLocomotive(locomotiveIdentifier: string, classCode: string) {
    if (this.isShadowLocomotive(locomotiveIdentifier)) {
      if (this.isNotBlank(classCode) && !this.isRemoteControlledPlatformLocomotive() && !this.isSlugLocomotive()) {
        this.shadowOverText = this.trimUpperCaseValue(classCode);
      }
    }
  }

  /**
   * Check for slug locomotive
   * @returns {boolean}
   * @memberOf LmsLocoSvgComponent
   */
  isSlugLocomotive(): boolean {
    return (this.loco && this.loco.clazz && (this.loco.clazz.toUpperCase() === 'SWMT' ||
      this.trimUpperCaseValue(this.loco.clazz) === 'RCPUSH' ||
      this.trimUpperCaseValue(this.loco.clazz) === 'RDSLUG' ||
      this.trimUpperCaseValue(this.loco.clazz) === 'MT6')) ? true : false;
  }

  isPTCEquippedSlug(): boolean {
    return (this.isPTCEquipped() && this.isSlugLocomotive()) ? true : false;
  }

  /**
   * Check for PTD Equipped with defect
   * @returns {boolean}
   * @memberOf LmsLocoSvgComponent
   */
  isPTCEquippedWithDefect(): boolean {
    return (this.loco && this.isNotBlank(this.loco.ptcIncident) &&
      this.trimUpperCaseValue(this.loco.ptcIncident) === 'Y') ? true : false;
  }

  /**
   * Check for PTC Equipped.
   * @returns {boolean}
   * @memberOf LmsLocoSvgComponent
   */
  isPTCEquipped(): boolean {
    return (this.loco && this.isNotBlank(this.loco.ptcEquipped) &&
      this.trimUpperCaseValue(this.loco.ptcEquipped) === 'Y') ? true : false;
  }

  /**
   * Check for remote controlled platform locomotive
   * @returns {boolean}
   * @memberOf LmsLocoSvgComponent
   */
  isRemoteControlledPlatformLocomotive(): boolean {
    return (this.loco && this.loco.clazz &&
      (this.trimUpperCaseValue(this.loco.clazz).startsWith('RCPH') ||
        this.trimUpperCaseValue(this.loco.clazz).startsWith('RCCAR'))) ? true : false;
  }

  /**
   * Check for feature code indicate heavy.
   * @returns {boolean}
   * @memberOf LmsLocoSvgComponent
   */
  isFeatureCodeIndicatingHeavy(): boolean {
    return (this.loco && this.isNotBlank(this.loco.iconDotIndicator) &&
      this.trimUpperCaseValue(this.loco.iconDotIndicator) === 'Y') ? true : false;
  }

  /**
   * Set background of locomotive.
   *
   * @memberof LmsLocoSvgComponent
   */
  setBackgroud() {

    if (this.loco) {
      if (this.isYardLocalScreen) {
        if (this.trimUpperCaseValue(this.loco.backgroundColor) === 'G') {
          this.locoIcon.backgroundClass = 'light-grey';
        } else if (this.trimUpperCaseValue(this.loco.backgroundColor) === 'P') {
          this.locoIcon.backgroundClass = 'pink';
        } else if (this.trimUpperCaseValue(this.loco.backgroundColor) === 'Y') {
          this.locoIcon.backgroundClass = 'yellow';
        } else {
          this.locoIcon.backgroundClass = 'white';
        }
      } else {
        if (this.loco.assignedPlannedFlag) {
          if (this.trimUpperCaseValue(this.loco.assignedPlannedFlag) === 'P') {
            this.locoIcon.backgroundClass = 'dark-yellow';
          } else {
            let icoPlannable = false;
            if (this.trainData
              && (!this.trainData.nextTerminal || (this.trainData.nextTerminal && this.trainData.nextTerminal.length === 0))) {
              icoPlannable = true;
            }
            if (this.isTerminalStatusSection && (this.trimUpperCaseValue(this.loco.qualifier) === 'S' || this.trimUpperCaseValue(this.loco.qualifier) === 'U')) {
              icoPlannable = true;
            }
            if (icoPlannable && (((!this.loco.plannedAssignment) || (this.loco.plannedAssignment
              && this.loco.plannedAssignment.trim().length === 0)) || ((!this.loco.plannedOrCurrentAssign) ||
                (this.loco.plannedOrCurrentAssign && this.loco.plannedOrCurrentAssign.trim().length === 0)))) {
              this.locoIcon.backgroundClass = 'light-blue';
            }
          }
        }
      }
    }
  }


  /**
   * Check, Is unit is available or not.
   * @returns {boolean}
   * @memberOf LmsLocoSvgComponent
   */
  isUnitIsAvailable(): boolean {
    return (this.loco && !this.isPlannedLoco(this.loco) &&
      this.isNotBlank(this.loco.qualifier) && (this.trimUpperCaseValue(this.loco.qualifier) === 'S' ||
        this.trimUpperCaseValue(this.loco.qualifier) === 'W')) ? true : false;
  }

  /**
   * Check, is unit has next planned assignement.
   * @returns {boolean}
   * @memberOf LmsLocoSvgComponent
   */
  isUnitHasNextPlannedAssignment(): boolean {
    let flag = false;
    if (this.loco.assignedPlannedFlag
      && this.loco.assignedPlannedFlag.trim().toUpperCase() !== 'P'
      && ((this.loco.plannedAssignment
        && this.loco.plannedAssignment.trim().length > 0) || (this.loco.plannedOrCurrentAssign
          && this.loco.plannedOrCurrentAssign.trim().length > 0))) {
      flag = true;
    }
    return flag;
  }

  /**
   * Get Thp information.
   * @memberof LmsLocoSvgComponent
   */
  getThpInfo(loco: LocoDetail): string {
    if (loco && loco.thpType) {
      if ((loco.thpDefault && this.trimUpperCaseValue(loco.thpDefault)) === 'D'
        || (loco.THPDefault && this.trimUpperCaseValue(loco.THPDefault) === 'D')) {
        this.locoIcon.thpClass = 'thp-gray';
      } else {
        this.locoIcon.thpClass = '';
      }
      let thpDesc = loco.thpType;
      if (loco.thpType.trim() === 'Svc Ctr/Shop') {
        thpDesc = 'S';
      } else if (loco.thpType.trim() === 'Main Track') {
        thpDesc = 'M';
      } else if (loco.thpType.trim() === 'Truck Fuel') {
        thpDesc = 'T';
      } else if (loco.thpType.trim() === 'Storage') {
        thpDesc = 'X';
      }
      return thpDesc;
    }
  }

  /**
   * Check, is discrepancy on aei reporting.
   * @returns {boolean}
   * @memberOf LmsLocoSvgComponent
   */
  isDiscrepancyOnAeiReporting(): boolean {
    return (this.loco && this.loco.questionMark &&
      this.loco.questionMark.toUpperCase() === 'Y') ? true : false;
  }

  setAxle() {
    if (this.loco && this.loco.axles) {
      if (this.loco.axles === '4') {
        this.locoIcon.wheel3Class = 'hidden';
        this.locoIcon.wheel4Class = 'hidden';
      }
    }
  }

  /**
   * Draw mile left and due out text.
   * @memberOf LmsLocoSvgComponent
   */
  drawMilesLeftAndDueOut() {
    this.locoIcon.isFormPastDue = (this.isNotBlank(this.loco.formPastDue)
      && this.trimUpperCaseValue(this.loco.formPastDue) === 'Y') ? true : false;

    if (this.isNotBlank(this.loco.miles)) {
      this.locoIcon.firstTextBelowLocomotive = '' + parseInt(this.loco.miles, 10);
    } else {
      this.locoIcon.firstTextBelowLocomotive = '0';
    }
    if (this.isNotBlank(this.loco.lastFueledDate) && this.loco.lastFueledDate.trim().length === 4) {
      this.locoIcon.firstTextBelowLocomotive += '-' + this.loco.lastFueledDate.substring(2, 4);
    } else if (this.isNotBlank(this.loco.lastFueledDate) && this.loco.lastFueledDate.trim().length > 4) {
      this.locoIcon.firstTextBelowLocomotive += '-' + this.loco.lastFueledDate.substring(3, 5);
    }
    // BUSINESS CHANGE: Use deadDate (formDueDead) for text chain display
    // formDueDead is now only populated when within proximity criteria (matching original formDue behavior)
    if (this.isNotBlank(this.loco.deadDate) && this.isNotBlank(this.formDueDead) &&
        this.trimUpperCaseValue(this.formDueDead.substring(0, 1)) !== 'X' &&
        (this.formDueDead && this.formDueDead.substring(0, 1)) !== ' ') {
      this.locoIcon.firstTextBelowLocomotive += '-' + this.formDueDead;
    }
    if (this.isNotBlank(this.loco.hstFuelCount)) {
      this.locoIcon.firstTextBelowLocomotive += '-' + this.loco.hstFuelCount;
    }
    if (this.isNotBlank(this.loco.nextTripDisplay)) {
      this.locoIcon.firstTextBelowLocomotive += '-' + this.loco.nextTripDisplay;
    }

    if (this.isNotBlank(this.loco.serviceDue)) {
      this.locoIcon.firstTextBelowLocomotive += '-' + this.loco.serviceDue;
    }
  }

  /**
   * Draw inner color of locomotive.
   * @memberOf LmsLocoSvgComponent
   */
  drawLocoStatus() {
    let bFormDue: boolean;
    let bShoppedStored: boolean;
    let bShopped: boolean;
    let bStored: boolean;
    let bDead: boolean;
    let bOtherProblem: boolean;

    let iconColor = '#FFFFFF';

    let isOOSIncident = false;
    if (this.loco && this.loco.listOfIncident) {
      for (let i = 0; i < this.loco.listOfIncident.length; i++) {
        const locoIncident: LocoIncident = this.loco.listOfIncident[i];
       // if (locoIncident && locoIncident.incidentType && locoIncident.incidentType.trim().toUpperCase() === 'D') {
        if (locoIncident && locoIncident.incidentType && locoIncident.incidentCode.trim().toUpperCase() === 'DAD') {
          isOOSIncident = true;
          break;
        }
      }
    }
    if (this.isShadowIcon && !this.isRemoteControlledPlatformLocomotive() && !this.isSlugLocomotive()) {
      iconColor = '#BDC1C2';
      this.locoIcon.locoPrimaryColor = '#BDC1C2';
      this.locoIcon.locoSecondaryColor = '#BDC1C2';
    } else {
      iconColor = '#FFFFFF';
    }
    let alertLevel = '0';

    const orangeColor = '#FF8000'; // ORANGE

    let isSecondaryConditionapplied = true;
    if (this.isNotBlank(this.loco.alertLevel)) {
      alertLevel = this.trimUpperCaseValue(this.loco.alertLevel);
    } else if (this.isNotBlank(this.loco.labAlert)) {
      alertLevel = this.trimUpperCaseValue(this.loco.labAlert);
    }


    if (this.isNotBlank(this.loco.deadDate) && this.isNotBlank(this.formDueDead) &&
      this.trimUpperCaseValue(this.formDueDead.substring(0, 1)) !== 'X' &&
      (this.formDueDead && this.formDueDead.substring(0, 1)) !== ' ') {
      bFormDue = true;
    } else {
      bFormDue = false;
    }

    bShoppedStored = (this.isNotBlank(this.loco.shoppedStored) &&
      (this.trimUpperCaseValue(this.loco.shoppedStored) === 'S' ||
        this.trimUpperCaseValue(this.loco.shoppedStored) === 'W')) ? true : false;

    if (bShoppedStored) {
      if (this.trimUpperCaseValue(this.loco.shoppedStored) === 'S') {
        bShopped = true;
        bStored = false;
      } else {
        bShopped = false;
        bStored = true;
      }
    }

    bDead = (this.isNotBlank(this.loco.deadFlag) &&
      this.trimUpperCaseValue(this.loco.deadFlag) === 'Y') ? true : false;

    bOtherProblem = (this.isNotBlank(this.loco.otherFlag) &&
      this.trimUpperCaseValue(this.loco.otherFlag) === 'Y') ? true : false;

    //this.lmsLoggerService.logDebug('Loco SVG -> for loco '+this.loco.locomotiveIdentifier+' Alert '+alertLevel+' dead '+bDead+' shopped '+bShoppedStored+' OOS '+isOOSIncident+' form due '+bFormDue);
    //this.lmsLoggerService.logDebug('First Icon red color '+((((alertLevel === '1') || (bDead || isOOSIncident) || (bShoppedStored && (alertLevel === '2'))) &&
    // (!bFormDue || (alertLevel === '2'))))+' Second Icon red color '+((bDead && bFormDue) || isOOSIncident));
    if (alertLevel === '1') {
      iconColor = '#FF80FF'; // LIGHT_PURPLE
      //O4518 added condition var : isOOSIncident "if atleast one OOS incident is found make the loco color as red"
    } else if ((((alertLevel === '1') || (bDead || isOOSIncident) || (bShoppedStored && (alertLevel === '2'))) &&
      (!bFormDue || (alertLevel === '2')))) {
      iconColor = '#FF0000'; // PURE_RED

    } else if (bFormDue) {
      iconColor = '#80FFFF'; // LIGHT_BLUE

    } else if (bOtherProblem) {
      iconColor = '#FFFF80'; // YELLOW

    } else if (bShopped) {
      iconColor = '#00FF00'; // GREEN

    } else if (bStored) {
      iconColor = '#80FF80'; // PALE_GREEN

    } else if (this.isNotBlank(this.loco.lowFuelIndicator) && this.trimUpperCaseValue(this.loco.lowFuelIndicator) === 'Y') {
      iconColor = orangeColor;

    } else if (alertLevel === '2') {
      iconColor = '#FFFFFF';
    }
    this.locoIcon.locoPrimaryColor = iconColor;

    if ((alertLevel === '1') || ((alertLevel === '1') && !((bShoppedStored)
      && ((bOtherProblem) || (bFormDue))))) {
      isSecondaryConditionapplied = false;
    }
    if (isSecondaryConditionapplied) {
      if (alertLevel === '2') {
        iconColor = '#FF80FF'; // LIGHT_PURPLE

      } else if (((bDead || isOOSIncident) && bFormDue)) {
        iconColor = '#FF0000'; // PURE_RED

      } else if ((this.locoIcon.locoPrimaryColor !== orangeColor) && this.isNotBlank(this.loco.lowFuelIndicator) &&
        (this.trimUpperCaseValue(this.loco.lowFuelIndicator) === 'Y')) {
        iconColor = orangeColor;

      } else if (((alertLevel === '0') && !bShoppedStored && bOtherProblem && bFormDue)) {
        iconColor = '#FFFF80'; // YELLOW

      } else if ((bShopped && (bFormDue || bOtherProblem))) {
        iconColor = '#00FF00'; // GREEN

      } else if ((bStored && (bFormDue || bOtherProblem))) {
        iconColor = '#80FF80'; // PALE_GREEN

      }
      this.locoIcon.locoSecondaryColor = iconColor;
    }
  }

  findTagInListOfIncident(tag: string) {
    return this.loco.listOfIncident && this.loco.listOfIncident.filter(x => x.incidentCode === tag).length > 0;
  }
  /**
  * This is used to set Locomotive outer color
  * @param {string} permanentTag
  * @param {string} locoTag
  * @param {string} assignedMaintPoint
  * @param {string} classCode
  * @memberOf LmsLocoSvgComponent
  */
  setLocomotiveOuterColor(permanentTag: string, locoTag: string, assignedMaintPoint: string, classCode: string) {
    this.locoIcon.locoBorderClass = 'black';
    this.locoIcon.locoBackgoundClass = 'bg-black';

    if (permanentTag) {
      this.locoIcon.bonnetText = permanentTag.toLowerCase();
    }

    let isDPFPresent = (this.loco.problemCodes && this.loco.problemCodes.indexOf('DPF') !== -1) ||
      this.findTagInListOfIncident('DPF');

     
      if (permanentTag && this.trimUpperCaseValue(permanentTag).startsWith('Y')) {
        if (this.isNotBlank(locoTag)) {
          this.locoIcon.bonnetText = locoTag.toLowerCase();
        } else {
          this.locoIcon.bonnetText = '';
        }

        if (this.trimUpperCaseValue(permanentTag) === 'YL') {
          if (this.isNotBlank(this.loco.locoAllocStation)) {
            // Allocated Yard and Local
            this.locoIcon.locoBorderClass = 'dark-green';
            this.locoIcon.locoBackgoundClass = 'bg-dark-green';
            this.locoIcon.locoBonnetTextClass = 'black-color';
          } else {
            // Unallocated Yard and Local
            this.locoIcon.locoBorderClass = 'lightPurple'; // LIGHT_PURPLE (255, 128, 255)
            this.locoIcon.locoBackgoundClass = 'bg-light-purple';
          }
        } else if (this.trimUpperCaseValue(permanentTag) === 'YS') {
          // Special Yard and Local
          this.locoIcon.locoBorderClass = 'dark-red';
          this.locoIcon.locoBackgoundClass = 'bg-dark-red';
        } else if (this.trimUpperCaseValue(permanentTag) === 'YC') {
          // SAC locations
          this.locoIcon.locoBorderClass = 'dodgerblue';
          this.locoIcon.locoBackgoundClass = 'bg-dodger-blue';
        } else {
          this.locoIcon.locoBorderClass = 'darkpurple';
          this.locoIcon.locoBackgoundClass = 'bg-dark-purple';
        }
      } else {
        if (permanentTag && (this.trimUpperCaseValue(permanentTag).startsWith('L') &&
          this.trimUpperCaseValue(permanentTag) !== 'LE') ||
          this.trimUpperCaseValue(permanentTag) === 'BH') {
          console.log('PERM STARTING WITH L');
          this.locoIcon.locoBackgoundClass = 'bg-blue';
          if (this.loco.problemCodes.length > 0 && this.loco.problemCodes.indexOf('DPF') !== -1) {
            if (this.loco.directionFacing && this.trimUpperCaseValue(this.loco.directionFacing) === 'B') {
              this.locoIcon.locoBorderClass = 'blue-red';
              this.locoIcon.backwardWheelsClass = 'red';
            }
            else {
              this.locoIcon.locoBorderClass = 'red-blue';
              this.locoIcon.backwardWheelsClass = 'blue';
              this.locoIcon.forwardWheelsClass = 'red';
            }
          }
          else {
            this.locoIcon.locoBorderClass = 'blue';
          }
        } else {
          if (this.trimUpperCaseValue(permanentTag) === 'BM') {
            // Boston and Maine
            this.locoIcon.locoBorderClass = 'darkolive';
            this.locoIcon.locoBackgoundClass = 'bg-dark-olive';

          } else if (this.trimUpperCaseValue(permanentTag) === 'LE') {
            // Leased
            // this.locomotiveInnerTextClass = this.middleUnderlineText;
            this.locoIcon.locoBorderClass = 'darkgoldenrod';
            this.locoIcon.locoBackgoundClass = 'bg-dark-goldenrod';

          } else if (this.trimUpperCaseValue(permanentTag) === 'MO') {
            // Modification Due only
            this.locoIcon.locoBorderClass = 'red';
            this.locoIcon.locoBackgoundClass = 'bg-red';

          }
          else if (this.trimUpperCaseValue(permanentTag) === 'MW') {
            // Maintenance of Way
            if (this.isNotBlank(locoTag)) {
              this.locoIcon.bonnetText = locoTag.toLowerCase();
            } else {
              this.locoIcon.bonnetText = '';
            }
            this.locoIcon.locoBorderClass = 'orange';
            this.locoIcon.locoBackgoundClass = 'bg-orange';

          } else if (this.trimUpperCaseValue(permanentTag) === 'PW') {
            // Locomotive Management special purpose
            this.locoIcon.locoBorderClass = 'teal';
            this.locoIcon.locoBackgoundClass = 'bg-teal';

          } else if (this.trimUpperCaseValue(permanentTag) === 'TC') {
            // Train Control Device equipped
            this.locoIcon.locoBorderClass = 'darkgray';
            this.locoIcon.locoBackgoundClass = 'bg-dark-gray';

          } else {
            if (this.isNotBlank(this.loco.locomotiveIdentifier) && !this.trimUpperCaseValue(this.loco.locomotiveIdentifier).startsWith('CSXT') &&
              !this.trimUpperCaseValue(this.loco.locomotiveIdentifier).startsWith('TORC')) {
              this.locoIcon.locoBorderClass = 'lightblue';

              this.locoIcon.locoBackgoundClass = 'bg-light-blue';
              this.locoIcon.locoBonnetTextClass = 'black-color';
            }
          }
        }
      }
    

    if (isDPFPresent && ((permanentTag && this.trimUpperCaseValue(permanentTag) !== 'MO') || !permanentTag)) {
      if (this.loco.directionFacing && this.trimUpperCaseValue(this.loco.directionFacing) === 'B') {
        this.locoIcon.locoBorderClass = this.locoIcon.locoBorderClass + ' trans-red-left';
       // this.locoIcon.locoBackgoundClass = 'bg-dark-gray';
        this.locoIcon.backwardWheelsClass = 'red';
      }
      else {
        this.locoIcon.locoBorderClass = this.locoIcon.locoBorderClass + ' trans-red-right';
        //this.locoIcon.locoBackgoundClass = 'bg-dark-gray';
        this.locoIcon.forwardWheelsClass = 'red';
      }
    } else if (isDPFPresent && ((permanentTag && this.trimUpperCaseValue(permanentTag) === 'MO') || !permanentTag)) {
      if (this.loco.directionFacing && this.trimUpperCaseValue(this.loco.directionFacing) === 'B') {
        this.locoIcon.locoBorderClass = 'red-green';
       //this.locoIcon.locoBorderClass = this.locoIcon.locoBorderClass + ' trans-green-left';
        this.locoIcon.locoBackgoundClass = 'bg-red';
        this.locoIcon.backwardWheelsClass = 'green';
      } else {
        this.locoIcon.locoBorderClass = 'green-red';
        //this.locoIcon.locoBorderClass = this.locoIcon.locoBorderClass + ' trans-green-right';
        this.locoIcon.locoBackgoundClass = 'bg-red';
        this.locoIcon.forwardWheelsClass = 'green';
      }
    }

    // commenting out the ET code since it is not needed moving forward. Just commented out for any future use
   /* 
   if (classCode && classCode.trim().length >= 2 && classCode.startsWith('ET')) {
      if (this.locoIcon.locoBorderClass === 'lightPurple' ||
        this.locoIcon.locoBorderClass === 'darkpurple' || this.locoIcon.locoBorderClass === 'dark-red' ||
        this.locoIcon.locoBorderClass === 'red' || this.locoIcon.locoBorderClass === 'orange' ||
        this.locoIcon.locoBorderClass === 'darkgoldenrod') {
        this.locoIcon.locoBorderClass = this.locoIcon.locoBorderClass + '-green';
        if (this.loco.directionFacing && this.trimUpperCaseValue(this.loco.directionFacing) === 'B') {
          this.locoIcon.backwardWheelsClass = 'green';
        } else {
          this.locoIcon.forwardWheelsClass = 'green';
        }
      } else {
        if (this.locoIcon.locoBorderClass === 'lightblue') {
          this.locoIcon.isLocoLightBlueBorder = true;
          this.locoIcon.locoBorderClass = this.locoIcon.locoBorderClass + '-green';
        }
        if (this.loco.directionFacing && this.trimUpperCaseValue(this.loco.directionFacing) === 'B') {
          this.locoIcon.backwardWheelsClass = 'green';
        } else {
          this.locoIcon.forwardWheelsClass = 'green';
        }
      }
    } 
    */
  }

  /**
   * This is used to set Question Marks
   * @memberOf LmsLocoSvgComponent
   */
  setQuestionMark() {
    this.locoIcon.isDiscrepancyOnAeiReporting = (this.loco.questionMark &&
      this.loco.questionMark.toUpperCase() === 'Y') ? true : false;
    this.locoIcon.isDiscrepancyOnGpsReporting = (this.loco.questionMark &&
      this.loco.questionMark.toUpperCase() === 'G') ? true : false;
    this.locoIcon.isGPSReportingSuspect = (this.loco.noGpsReporting &&
      this.loco.noGpsReporting.toUpperCase() === 'Y') ? true : false;

    if (this.locoIcon.isDiscrepancyOnAeiReporting) {
      this.locoIcon.isQuestionMarkDisplayed = true;
      this.locoIcon.questionMarkClass = 'layer4 red';

    } else if (this.locoIcon.isDiscrepancyOnGpsReporting) {
      this.locoIcon.isQuestionMarkDisplayed = true;
      this.locoIcon.questionMarkClass = 'layer4 yellow';

    } else if (this.locoIcon.isGPSReportingSuspect) {
      this.locoIcon.isQuestionMarkDisplayed = true;
      this.locoIcon.questionMarkClass = 'layer4 blue';
    }
  }

  /**
   * This is used to configure antena.
   * @memberOf LmsLocoSvgComponent
   */
  configureAntenna() {
    if (this.isNotBlank(this.loco.rduInstalled) &&
      this.trimUpperCaseValue(this.loco.rduInstalled) === 'E') {
      this.setAntenna('blue');

    } else if (this.isNotBlank(this.loco.rduInstalled) &&
      this.trimUpperCaseValue(this.loco.rduInstalled) === 'Y') {
      this.setAntenna('black');

    } else if (this.isNotBlank(this.loco.rduInstalled) &&
      this.trimUpperCaseValue(this.loco.rduInstalled) === 'P') {
      this.setAntenna('red');
    }
  }

  /**
   * This is used to set Antenna
   * @param {string} colorClass
   * @memberOf LmsLocoSvgComponent
   */
  setAntenna(colorClass: string) {
    this.locoIcon.antennaColorClass = colorClass;
    this.locoIcon.isAntennaDisplayed = true;
  }

  /**
   * This is used to display projected Out Text
   * @memberOf LmsLocoSvgComponent
   */
  displayProjectedOut() {
    this.locoIcon.projectedOutClass = 'black';
    if (this.isDueOutShopScreen || this.locoIcon.isStoredUnit) {
      this.locoIcon.projectedOutClass = 'red';
      if (this.isDueOutShopScreen) {
        // Format is hhmm.yymmdd.
        if (this.loco.genericTime) {
          this.locoIcon.projectedOutText = this.loco.genericTime;
        }
        if (this.loco.genericDate) {
          this.locoIcon.projectedOutText += '.' + this.loco.genericDate;
        }
      } else {
        this.locoIcon.projectedOutText = this.loco.genericDate; // Format is yymmdd.
      }
    }
  }

  /**
   * Check for loco is assigned or planned.
   * @param {LocoDetail} loco
   * @returns {boolean}
   * @memberOf LmsLocoSvgComponent
   */
  isPlannedLoco(loco: LocoDetail): boolean {
    let flag: boolean;
    if (loco) {
      if (loco.assignedPlannedFlag && loco.assignedPlannedFlag.trim().toUpperCase() === 'P') {
        flag = true;
      } else if ((loco.plannedAssignment && loco.plannedAssignment.trim().length > 0) || (loco.plannedOrCurrentAssign && loco.plannedOrCurrentAssign.trim().length > 0)) {
        flag = true;
      }
    }
    return flag;
  }

  /**
  * This is used to get Day Difference between two dates
  * @param {Date} date1
  * @param {Date} date2
  * @returns {number}
  * @memberOf LmsLocoSvgComponent
  */
  getDayDiff(date1: Date, date2: Date): number {
    const timeDiff = date1.getTime() - date2.getTime();
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
  }

  /**
   * Show timer for on terminal, on ready states on terminal screen.
   * @param {string} id
   * @param {string} hour
   * @param {string} minute
   * @memberOf LmsLocoSvgComponent
   */
  countdown(id: string, hour: string, minute: string, timeDiff: number) {
    let minutes = 0; let displayHour = 0;
    if (timeDiff) {
      minutes += timeDiff;
    }
    if (hour) {
      minutes += parseInt(hour, 10) * 60;
    }
    if (minute) {
      minutes += parseInt(minute, 10);
    }
    const dispMin = minutes % 60;
    displayHour = displayHour + Math.floor(minutes / 60);
    minutes = minutes % 60;
    if (displayHour <= 99 && dispMin <= 59) {
      this.locoIcon.unitArrivedAtTerminalMinute = (dispMin < 10 ? '0' : '') + String(dispMin);
      this.locoIcon.unitArrivedAtTerminalHour = (displayHour < 10 ? '0' : '') + String(displayHour);
    }
    this.locoIcon.intervalId = setInterval(() => {
      minutes++;
      const dMin = minutes % 60;
      displayHour = displayHour + Math.floor(minutes / 60);
      minutes = minutes % 60;
      if (displayHour <= 99 && dMin <= 59) {
        this.locoIcon.unitArrivedAtTerminalMinute = (dMin < 10 ? '0' : '') + String(dMin);
        this.locoIcon.unitArrivedAtTerminalHour = (displayHour < 10 ? '0' : '') + String(displayHour);
      }
    }, 60000);

    if (this.tab) {
      if (!this.tab.intervalIdArr) {
        this.tab.intervalIdArr = [];
      }
      if (this.locoIcon.intervalId && this.locoIcon.intervalId.data) {
        this.tab.intervalIdArr.push(this.locoIcon.intervalId.data.handleId);
      }
    }

  }

  /**
  * This is used to check whether value is blank or note
  * @param {string} value
  * @returns {boolean}
  * @memberOf LmsLocoSvgComponent
  */
  isNotBlank(value: string): boolean {
    return (value && value.trim().length > 0);
  }
  /**
    * This is used to check whether value is blank or note
    * @param {string} value
    * @returns {boolean}
    * @memberOf LmsLocoSvgComponent
    */
  isBlank(value: string): boolean {
    return (value && value.trim().length === 0);
  }

  /**
   * This is used to convert into UpperCase
   * @param {string} value
   * @returns {string}
   * @memberOf LmsLocoSvgComponent
   */
  trimUpperCaseValue(value: string): string {
    return value && value.trim().toUpperCase();
  }

  /**
   * Set Inner Cell Border of locomotive.
   * @memberof LmsLocoSvgComponent
   */
  setInnerCellBorder() {
    if (this.loco.innerCellBorder === 'R') {
      // PURE_RED
    } else if (this.loco.innerCellBorder === 'Y') {
      // DARK_YELLOW
    }
  }
}
